// extracted by mini-css-extract-plugin
export default {"opacity":"OpacitySlider_opacity__wnpzk"};